export default "__VITE_ASSET__BoCUCaBv__"